import useSWR from 'swr';
import { getBoard } from '@gorilla/common/src/lib/monday-api/api';
import { mondayClient } from '../services/monday';

// shared by the widget list and the editor - SWR dedupes on the key, so the board is fetched once
export function useBoard(boardId: number | undefined) {
  return useSWR(
    boardId ? `/board/${boardId}` : null,
    async () => {
      return await getBoard(mondayClient, boardId!);
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );
}
